





































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Acl, ResourceClaim, ResourceType } from "@/services/security/types";
import { userGroupResourceAclFields } from "@/components/users/fields/userGroupResourceAclFields";
import AddResourceMenu from "@/components/users/AddResourceMenu.vue";
import SelectChannelModal from "@/components/channels/modals/SelectChannelModal.vue";
import SelectSolutionModal from "@/components/solutions/modals/SelectSolutioModal.vue";
import SelectContentTemplateModal from "@/components/contentTemplates/modals/SelectContentTemplateModal.vue";
import { Channel } from "@/services/channels/types";
import { Solution } from "@/services/solutions/types";
import { ContentTemplate } from "@/services/contentTemplates/types";
import ResourceAclDeleteModal from "@/components/users/modals/ResourceAclDeleteModal.vue";
@Component({
    components: {
        ResourceAclDeleteModal,
        SelectContentTemplateModal,
        AddResourceMenu,
        SelectChannelModal,
        SelectSolutionModal
    }
})
export default class UserGroupResourcesACL extends Vue {
        @Prop() acl!: Acl[];
        @Prop() collapseState!: boolean;
        // local state
        localCollapseState = true;
        localAcl = [] as Acl[];
        searchQuery = "";
        fields = userGroupResourceAclFields;
        resourceClaim = ResourceClaim;
        resourceType = ResourceType;
        filterResourceType = "";
        // lifecycle hooks
        mounted() {
            this.localCollapseState = this.collapseState;
        }

        // watchers
        @Watch("acl")
        onPropertyChanged(value: boolean, oldValue: any) {
            this.localAcl = this.acl.filter(acl => acl.type !== "Folder");
        }

        // computed
        get filteredData() {
            return this.localAcl && this.localAcl
                .filter(x => (this.searchQuery.length === 0 ||
                    (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()))) &&
                    (this.filterResourceType.length === 0 || x.type === this.filterResourceType));
        }

        // methods
        aclTitle(type: string) {
            const t = type.toLowerCase();
            if (t === "channel") return this.$t("channels.editTitle");
            if (t === "solution") return this.$t("solution.editTitle");
            if (t === "template" || t === "contenttemplate") return this.$t("contentTemplates.edit");
            return "";
        }

        onChannelSelected(channels: Channel[]) {
            channels.forEach(channel => {
                const acl = {
                    resourceId: channel.id,
                    name: channel.name,
                    claim: this.resourceClaim.Access,
                    type: this.resourceType.Channel
                } as Acl;

                this.addAcl(acl);
            });
        }

        onSolutionSelected(solutions: Solution[]) {
            solutions.forEach(solution => {
                const acl = {
                    resourceId: solution.id,
                    name: solution.name,
                    claim: this.resourceClaim.Access,
                    type: this.resourceType.Solution
                } as Acl;

                this.addAcl(acl);
            });
        }

        onContentTemplateSelected(cts: ContentTemplate[]) {
            cts.forEach(ct => {
                const acl = {
                    resourceId: ct.id,
                    name: ct.name,
                    claim: this.resourceClaim.Access,
                    type: this.resourceType.ContentTemplate,
                    templateType: ct.type
                } as Acl;

                this.addAcl(acl);
            });
        }

        addAcl(acl: Acl) {
            if (this.localAcl.some(x => x.resourceId === acl.resourceId)) {
                return;
            };
            this.localAcl.unshift(acl);
        }

        onOpenResourcePrompt(resource: string) {
            switch (resource) {
            case "channel":
                (this.$refs.selectChannelModal as any).open(true);
                return;
            case "solution":
                (this.$refs.selectSolutionModal as any).open(null, false, true);
                return;
            case "contentTemplate":
                (this.$refs.selectContentTemplateModal as any).open(true);
            }
        }

        getResourceDetailsUrl(acl: Acl) {
            switch (acl.type) {
            case "Channel":
                return `/channel/${acl.resourceId}/update`;
            case "Solution":
                return `/solutions/${acl.resourceId}/update`;
            case "ContentTemplate":
                if (acl.templateType === "fixedhtml") {
                    return `/templates/${acl.resourceId}/update/fixedhtml`;
                } else if (acl.templateType === "html") {
                    return `/templates/${acl.resourceId}/update/html`;
                }
                break;
            default:
                return "/";
            }
        }

        removeResource(acl: Acl) {
            (this.$refs.deleteAclModal as any).open(acl.resourceId, acl.name);
        }

        onDeleted(id: string) {
            const item = this.localAcl.find(x => x.resourceId === id);
            if (!item) {
                return;
            }
            this.localAcl = this.localAcl.filter(x => x.resourceId !== id);
        }

        clearFilter() {
            this.filterResourceType = "";
        }

        // events
        emitData() {
            this.$emit("aclUpdated", this.localAcl);
        }

        setState(state:boolean) {
            if (this.localCollapseState === state) return;

            this.localCollapseState = state;
            this.$emit("componentStateChanged", { name: "UserGroupResourcesACL", state: state });
        }
}
